import { Badge } from "@/components/ui/badge";
import { LANE_META, LANE_ORDER, type LaneCounts } from "./task-type-meta";

/**
 * Small shared marks for the dispatch surfaces.
 *
 * Ported from admin-web's `dispatch-v2/atoms.tsx` so a stop, a lane count and a
 * trip status render identically in both consoles. Both apps are shadcn, so
 * these consume the same `Badge` primitive rather than restating its styling.
 */

/**
 * One square per lane that has work at this stop, coloured by lane and showing
 * the count — the compact form the stop list and the map markers share.
 *
 * Lanes with nothing at this stop are omitted entirely rather than shown as a
 * zero: a row of zeroes is noise, and the absence is the information.
 */
export function LaneChips({
  counts,
  size = 16,
}: {
  counts: LaneCounts;
  size?: number;
}) {
  const lanes = LANE_ORDER.filter((lane) => counts[lane] > 0);
  if (lanes.length === 0) return null;

  return (
    <span className="flex items-center gap-1">
      {lanes.map((lane) => (
        <Badge
          key={lane}
          title={LANE_META[lane].label}
          className="rounded border-0 font-bold tabular-nums text-white"
          style={{
            background: LANE_META[lane].color,
            minWidth: size,
            height: size,
            fontSize: size * 0.62,
            padding: "0 3px",
          }}
        >
          {counts[lane]}
        </Badge>
      ))}
    </span>
  );
}
